module.exports = __webpack_public_path__ + "static/media/474.ba847072.webp";